/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CompanyRegistrySearchResponse,
  Error,
  SearchCompanyRegistryParams,
  SupportedCountriesResponse
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Search public company registries for autocomplete. Returns matching companies from government data sources like AJPES (Slovenia). Use this to auto-fill customer details when creating invoices.
 * @summary Search company registry
 */
export type searchCompanyRegistryResponse200 = {
  data: CompanyRegistrySearchResponse
  status: 200
}

export type searchCompanyRegistryResponse400 = {
  data: Error
  status: 400
}

export type searchCompanyRegistryResponse401 = {
  data: Error
  status: 401
}

export type searchCompanyRegistryResponse403 = {
  data: Error
  status: 403
}

export type searchCompanyRegistryResponse404 = {
  data: Error
  status: 404
}

export type searchCompanyRegistryResponse500 = {
  data: Error
  status: 500
}

export type searchCompanyRegistryResponseSuccess = (searchCompanyRegistryResponse200) & {
  headers: Headers;
};
export type searchCompanyRegistryResponseError = (searchCompanyRegistryResponse400 | searchCompanyRegistryResponse401 | searchCompanyRegistryResponse403 | searchCompanyRegistryResponse404 | searchCompanyRegistryResponse500) & {
  headers: Headers;
};

export type searchCompanyRegistryResponse = (searchCompanyRegistryResponseSuccess | searchCompanyRegistryResponseError)

export const getSearchCompanyRegistryUrl = (params: SearchCompanyRegistryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/company-registry/search?${stringifiedParams}` : `/company-registry/search`
}

export const searchCompanyRegistry = async (params: SearchCompanyRegistryParams, options?: RequestInit): Promise<searchCompanyRegistryResponse> => {
  
  return customFetch<searchCompanyRegistryResponse>(getSearchCompanyRegistryUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Returns a list of country codes for which company registry data is available. Use this to conditionally show the company autocomplete feature based on entity's country.
 * @summary Get supported countries
 */
export type getSupportedCountriesResponse200 = {
  data: SupportedCountriesResponse
  status: 200
}

export type getSupportedCountriesResponse400 = {
  data: Error
  status: 400
}

export type getSupportedCountriesResponse401 = {
  data: Error
  status: 401
}

export type getSupportedCountriesResponse403 = {
  data: Error
  status: 403
}

export type getSupportedCountriesResponse404 = {
  data: Error
  status: 404
}

export type getSupportedCountriesResponse500 = {
  data: Error
  status: 500
}

export type getSupportedCountriesResponseSuccess = (getSupportedCountriesResponse200) & {
  headers: Headers;
};
export type getSupportedCountriesResponseError = (getSupportedCountriesResponse400 | getSupportedCountriesResponse401 | getSupportedCountriesResponse403 | getSupportedCountriesResponse404 | getSupportedCountriesResponse500) & {
  headers: Headers;
};

export type getSupportedCountriesResponse = (getSupportedCountriesResponseSuccess | getSupportedCountriesResponseError)

export const getGetSupportedCountriesUrl = () => {


  

  return `/company-registry/countries`
}

export const getSupportedCountries = async ( options?: RequestInit): Promise<getSupportedCountriesResponse> => {
  
  return customFetch<getSupportedCountriesResponse>(getGetSupportedCountriesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

